import axios from "axios";
import config from "./config";

const GetMarkets = async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_API}/api/market/GetPrices`,
      config()
    );
    return { status: 200, payload: data };
  } catch (error) {
    return handleError(error);
  }
};

const handleError = (error) => {
  if (error.response) return { status: error.response.status, payload: null };
  return { status: 500, payload: null };
};

export default GetMarkets;
